<div class="task-assignment-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'assign tasks' | translate: ['tmc.task-assignment-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="dialog-content">
      <div class="task-grid">
        <ng-container *ngFor="let t of tasks; let i = index">
          <div class="center cut-content" style="grid-column: 1;" [ngStyle]="{'grid-row': i + 1} ">
            <mat-checkbox [(ngModel)]="t.selected" [ngModelOptions]="{standalone: true}" [disabled]="t.done">
              {{t.nameDictionaryKey | translate:[t.nameDictionaryKey, translationService.language]}} (<span
                class="italic">{{t.type |
                translate: ['tmc.task-assignment-dialog.type.' + t.type, translationService.language]}}</span>)
            </mat-checkbox>
          </div>

          <mat-form-field style="grid-column: 2;" [ngStyle]="{'grid-row': i + 1}">
            <mat-label>
              {{'actionType' | translate: ['tmc.task-assignment-dialog.relevance', translationService.language]}}
            </mat-label>

            <mat-select [(ngModel)]="t.relevance" [disabled]="!t.selected || t.done"
              *ngIf="t.type === taskType.CHECK || t.type === taskType.DOCUMENT || t.type === taskType.PICTURE || t.type === taskType.PICTURE_SERIES">
              <mat-option *ngFor="let o of relevanceOptions" [value]="o">
                {{o | translate: ['tmc.task-assignment-dialog.relevance.' + o, translationService.language]}}
              </mat-option>
            </mat-select>

            <mat-select [(ngModel)]="t.relevance" [disabled]="!t.selected || t.done"
              *ngIf="t.type === taskType.MESSAGE">
              <mat-option *ngFor="let o of relevanceOptionsForMessages" [value]="o">
                {{o | translate: ['tmc.task-assignment-dialog.relevance.' + o, translationService.language]}}
              </mat-option>
            </mat-select>

            <mat-select [(ngModel)]="t.relevance" [disabled]="!t.selected || t.done"
              *ngIf="t.type === taskType.ATTRIBUTE_CHANGE">
              <mat-option *ngFor="let o of relevanceOptionsForAttrubteChange" [value]="o">
                {{o | translate: ['tmc.task-assignment-dialog.relevance.' + o, translationService.language]}}
              </mat-option>
            </mat-select>

          </mat-form-field>

          <mat-form-field style="grid-column: 3;" [ngStyle]="{'grid-row': i + 1}"
            *ngIf="processingStatusOptions != null && processingStatusOptions.length > 0">
            <mat-label>
              {{'processing status' | translate: ['tmc.task-assignment-dialog.processing-status',
              translationService.language]}}
            </mat-label>
            <mat-select [(ngModel)]="t.processingStatus"
              [disabled]="!t.selected || t.done || (t.relevance !== taskRelevance.AUTOMATICALLY_ON_PROCESSING_STATUS && t.relevance !== taskRelevance.BEFORE_PROCESSING_STATUS)">
              <mat-option *ngFor="let o of processingStatusOptions" [value]="o.key">
                {{o.dictionaryKey | translate: [o.dictionaryKey, translationService.language]}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </ng-container>
      </div>
    </div>

    <i class="horizontal-divider"></i>
    <div class="messages"></div>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancelDialog()">{{'cancel' |
        translate:['shared.selection-dialog.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="confirm()" class="confirm-button" [disabled]="false">{{'confirm' |
        translate:['tmc.task-assignment-dialog.action.confirm', translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>
